// src/components/DirectoryFooter/DirectoryFooter.jsx
import { useNavigate } from "react-router-dom";
import "./DirectoryFooter.css";
import Facebook from '../../../../icons/facebook.png';
import Instagram from '../../../../icons/instagram.png';

function DirectoryFooter() {
 const navigate = useNavigate();
 const year = new Date().getFullYear();

 const go = (path) => navigate(path);

 return (
  <footer className="dir-footer">
   <div className="dir-footer-inner">
    <div className="dir-footer-brand">
     <h3>SportingHip</h3>

     <p>
      We help people find local sports programs and do our best to keep
      listings clear, accurate, and up to date.
     </p>

     <p className="dir-footer-email">
      Contact:{" "}
      <a href="mailto:hello@sportinghip.com?subject=SportingHip Contact">
       hello@sportinghip.com
      </a>
     </p>

     <div className="dir-footer-socials">
      <a href="https://www.facebook.com/profile.php?id=61577467378205" aria-label="Facebook">
       <img
        src={Facebook}
        alt="Facebook"
        className="dir-footer-social-img dir-footer-social-img-facebook"
       />
      </a>

      <a href="https://www.instagram.com/sportinghip/" aria-label="Instagram">
       <img
        src={Instagram}
        alt="Instagram"
        className="dir-footer-social-img dir-footer-social-img-instagram"
       />
      </a>

     </div>
    </div>

    {/* <div className="dir-footer-column">
     <h4>For Organizations</h4>

     <button type="button" onClick={() => go("/demo")}>
      Try League Management Demo
     </button>
    </div> */}

    <div className="dir-footer-column">
     <h4>Company</h4>

     <button type="button" onClick={() => go("/about")}>
      About
     </button>

     <button type="button" onClick={() => go("/privacy")}>
      Privacy
     </button>

     <button type="button" onClick={() => go("/terms")}>
      Terms
     </button>
    </div>
   </div>

   <div className="dir-footer-bottom">
    <p>
     Program details may change by season. Please check the official
     organization website for the latest schedules, fees, and registration info.
    </p>

    <span>© {year} SportingHip. All rights reserved.</span>
   </div>
  </footer>
 );
}

export default DirectoryFooter;